<span class="flex">
  <!--  Search media content then add it to context -->
  @if (canSearchContents) {
    <div
      class="transition-container"
      (mouseenter)="onMouseEnter()"
      (mouseleave)="onMouseLeave()"
    >
      <p-autoComplete
        #autoComplete
        [hidden]="!addContextHovered"
        [showClear]="true"
        @fadeScale
        [suggestions]="searchResults"
        [virtualScrollItemSize]="20"
        (completeMethod)="search($event.query)"
        (onSelect)="selectSearchResult($event.value)"
        styleClass="full-width-autocomplete"
        placeholder="Tapez pour rechercher un contenu..."
        [inputStyle]="{ width: '300px' }"
        [style.width.%]="100"
        [scrollHeight]="'500px'"
        optionLabel="title"
      >
        <ng-template
          let-result
          pTemplate="item"
        >
          <div class="flex align-items-center gap-2">
            <span style="font-size: 12px">{{ result.date | date: "dd MMMM yyyy" : "CEST" }} - </span>
            <span style="font-size: 12px">{{ result.type | searchTypeToLabel }} - </span>
            <span>{{ result.title }}</span>
          </div>
        </ng-template>
      </p-autoComplete>
      @if (!addContextHovered) {
        <button
          class="static-button p-button-secondary p-button-outlined no-outline mr-2"
          type="button"
          pButton
          label=""
          pTooltip="Ajouter du contenu"
          i18n-pTooltip="@@chat_add_context_menu"
          icon="fa fa-search"
        ></button>
      }
    </div>
  }
  @if (!canSearchContents || !addContextHovered) {
    <!-- Add existing file to context -->
    <button
      class="p-button-secondary p-button-outlined no-outline mr-2"
      pButton
      id="add-context-menu"
      type="button"
      (click)="selectExistingFile()"
      label=""
      pTooltip="Ajouter du contenu"
      i18n-pTooltip="@@chat_add_context_menu"
      icon="pi pi-plus"
    ></button>

    <!-- Upload a new file then add it to context -->
    <p-fileUpload
      #fileUpload
      mode="basic"
      [accept]="validExtensions.join(',')"
      [customUpload]="true"
      (uploadHandler)="uploadHandler($event)"
      (onError)="onError($event)"
      [maxFileSize]="MAX_FILE_SIZE"
      [multiple]="true"
      [auto]="true"
      chooseIcon="pi pi-upload"
      styleClass="p-button-secondary p-button-outlined no-outline"
      pTooltip="Parcourir les fichiers"
      i18n-pTooltip="@@file_content_list_upload_button"
    />
  }
</span>
